import { render } from "./Itp.vue?vue&type=template&id=08d93539&scoped=true"
import script from "./Itp.vue?vue&type=script&lang=js"
export * from "./Itp.vue?vue&type=script&lang=js"

import "./Itp.vue?vue&type=style&index=0&id=08d93539&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08d93539"

export default script